<ng-container *ngIf="!isCampaign; else campaign">
  <div class="container">
    <div class="header">
      <h1>Pacotes de créditos</h1>
    </div>
    <div class="body">
      <div class="selector">
        <h1>
          Escolha o valor da recarga:
        </h1>

        <div class="custom-select" [class.open]="isOpen">
          <div class="select-trigger" (click)="toggleSelect()" id="select-consulta-product">

            <span *ngIf="selectedOption">
              <ng-container *ngIf="productService.isVariableProduct(selectedOption.product); else displayNormal">
                <div class="custom-value-wrapper">
                  <span>Outro valor R$</span>
                  <input type="number" class="input-custom-value" [(ngModel)]="customPackageValue" [value]="customValue"
                    (input)="updateCustomValue($event.target.value)" (focusout)="checkCustomValue($event)">
                </div>
              </ng-container>

              <ng-template #displayNormal>
                R$
                <span class="integerPart">{{ getFormattedValue(selectedOption.baseValue).integerPart }}</span>
                <span class="decimalPart">,{{ getFormattedValue(selectedOption.baseValue).decimalPart }}</span>
              </ng-template>
            </span>

            <span *ngIf="!selectedOption">Selecione uma opção</span>

            <img src="/assets/images/icons-stepper/chevron_left.svg">
          </div>
          <ul class="options-list">
            <li *ngFor="let option of packagesFiltered" (click)="selectOption(option)">
              <ng-container *ngIf="productService.isVariableProduct(option.product); else valorNormal">
                Outro valor
              </ng-container>
              <ng-template #valorNormal>
                R$ {{option?.baseValue.toFixed(2).replace('.', ',').replace(",00","")}}
              </ng-template>
            </li>
          </ul>
        </div>
        <div class="overlay" *ngIf="isOpen" (click)="isOpen = false"></div>
        <p class="error-message-customValue" *ngIf="showCustomValueError">Você não pode adiquirir esse produto por menos
          de R$ {{selectedOption.baseValue}} </p>

        <button (click)="buy()">
          Comprar créditos
        </button>
        <p>{{packagesFiltered[0]?.footnote?.title}}</p>
      </div>
      <div class="content" *ngIf="selectedOption">
        <h1>
          Com esse valor, você consegue escolher uma ou mais opções abaixo:
        </h1>

        <div class="features">
          <div class="feature-list" *ngIf="selectedOption?.featureList?.length > 0">
            <ng-container *ngFor="let feature of selectedOption?.featureList; let last = last">
              <div class="feature">
                <div class="contentLeft">
                  <p class="quantity">
                    {{feature.requests}}
                  </p>
                </div>
                <div class="contentRight">
                  <p class="featureName">
                    {{feature.name}}
                  </p>
                  <p class="featureValue" *ngIf="feature.fromValue || feature.toValue">
                    ( <span class="afterValue">
                      {{feature.toValue || feature.fromValue }}
                    </span>
                    )
                  </p>
                </div>
              </div>
              <div class="line" *ngIf="!last">
                <p>ou</p>
                <hr>
              </div>
            </ng-container>
            <div class="line" *ngIf="selectedOption?.featureList.length > 0">
              <hr>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #campaign>
  <div class="container campaign">
    <div class="header">
      <h1>Pacotes de créditos</h1>
      <h2>compre créditos quando precisar</h2>
    </div>
    <div class="body">
      <div class="selector">
        <h1>
          Escolha o valor da recarga:
        </h1>

        <div class="custom-select" [class.open]="isOpen">
          <div class="select-trigger" [class.open]="isOpen" (click)="toggleSelect()" id="select-consulta-product">

            <span *ngIf="selectedOption">
              <ng-container *ngIf="productService.isVariableProduct(selectedOption.product); else displayNormal">
                <div class="custom-value-wrapper">
                  <span>Outro valor R$</span>
                  <input type="number" class="input-custom-value" [(ngModel)]="customPackageValue" [value]="customValue"
                    (input)="updateCustomValue($event.target.value)" (focusout)="checkCustomValue($event)">
                </div>
              </ng-container>
              <ng-template #displayNormal>
                <div class="price-container">
                  <div class="from"
                    *ngIf="selectedOption?.appliedDiscounts?.length > 0 && selectedOption.discountedValue !== 0">
                    De R$ {{selectedOption.baseValue.toFixed(2).replace('.', ',')}}
                  </div>
                  <div class="value-wrapper">
                    R$
                    <span class="integerPart">{{ getFormattedValue(selectedOption.totalValue).integerPart }}</span>
                    <span class="decimalPart">,{{ getFormattedValue(selectedOption.totalValue).decimalPart }}</span>
                  </div>
                </div>
              </ng-template>
            </span>

            <span *ngIf="!selectedOption">Selecione uma opção</span>

            <img src="/assets/images/icons-stepper/chevron_left.svg">
          </div>
          <ul class="options-list">
            <li *ngFor="let option of packagesFiltered"
              [ngClass]="{selected: selectedOption?.product._id === option.product._id, discounted: option?.appliedDiscounts?.length > 0 && option.discountedValue !== 0}"
              (click)="selectOption(option)">
              <ng-container *ngIf="productService.isVariableProduct(option.product); else standardPackage">
                <div class="optionBody">
                  <div class="simpleValue">Escolher outro valor</div>
                </div>
              </ng-container>
              <ng-template #standardPackage>
                <div class="optionBody"
                  *ngIf="option?.appliedDiscounts?.length > 0 && option.discountedValue !== 0; else noDiscount">
                  <div class="line">
                    <div class="profitable" *ngIf="option.profitable">
                      Mais vantajoso
                    </div>
                  </div>
                  <div class="line">

                    <div class="from">
                      de R$ {{option?.baseValue.toFixed(2).replace('.', ',')}}
                    </div>
                    <div class="to">
                      Por R$ {{option?.totalValue.toFixed(2).replace('.', ',')}}
                    </div>


                  </div>
                  <div class="line">
                    <div class="economyValue">
                      Economia de R$ {{(option.baseValue - option.totalValue).toFixed(2).replace('.',',')}}
                    </div>
                    <div class="discountPercentage">
                      {{(((option.baseValue - option.totalValue) / option.baseValue) * 100).toFixed(0)}}% OFF
                    </div>
                  </div>
                </div>
                <ng-template #noDiscount>
                  <div class="simpleValue">R$ {{option?.baseValue.toFixed(2).replace('.', ',')}}</div>
                </ng-template>
              </ng-template>
              <mat-icon *ngIf="selectedOption?.product._id === option.product._id" class="checkIcon">check</mat-icon>
            </li>
          </ul>
        </div>
        <div class="overlay" *ngIf="isOpen" (click)="isOpen = false"></div>
      </div>
      <div class="content" *ngIf="selectedOption">
        <h1>
          Com esse valor, você consegue escolher uma ou mais opções abaixo:
        </h1>

        <div class="features">
          <div class="feature-list" *ngIf="selectedOption?.featureList?.length > 0">
            <ng-container *ngFor="let feature of selectedOption?.featureList; let last = last">
              <div class="feature">
                <div class="contentLeft">
                  <p class="quantity">
                    {{feature.requests}}
                  </p>
                </div>
                <div class="contentRight">
                  <p class="featureName">
                    {{feature.name}}
                  </p>
                  <p class="featureValue" *ngIf="feature.fromValue || feature.toValue">
                    ( <span class="afterValue">
                      {{feature.toValue}}
                    </span>
                    )
                  </p>
                </div>
              </div>
              <div class="line" *ngIf="!last">
                <p>ou</p>
                <hr>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="footer">
        <button (click)="buy()">
          Comprar créditos
        </button>
        <p>{{packagesFiltered[0]?.footnote?.title}}</p>
      </div>
    </div>
  </div>
</ng-template>